export function filterMonitoringPenagihan(data, transfer, jenisRumpun) {
  return data.filter((row) => {
    const isTransfer = row.transfer === true;
    const isUmiha = (row.rumpun?.nama || '').toUpperCase().includes('UMIHA');
    return (transfer === 'semua' || isTransfer === (transfer === 'ya')) &&
      (jenisRumpun === 'semua' || isUmiha === (jenisRumpun === 'UMIHA'));
  });
}
